import axios from "axios";
export default {
    openBox: (id, cancelToken) =>
        axios.get(`/api/cashRegister/${id}/open-box`, { cancelToken }),
};
